import { Component, OnInit } from '@angular/core';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-add-budget-allocation',
  templateUrl: './add-budget-allocation.component.html',
  styleUrls: ['./add-budget-allocation.component.scss']
})
export class AddBudgetAllocationComponent implements OnInit {
  items: MenuItem[];

  constructor() { }

  ngOnInit(): void {
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
    ];
  }

}
